import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/** Properties for the staging area selection state command. */
export type AifcStagingSelectionStateCommandProperties = CommandProperties & {
	contentType: 'page';
	/** The host product's content identifier (e.g., Confluence contentId). */
	contentId: string;
	/** Whether the user currently has a non-empty selection in the staging area document. */
	hasSelection: boolean;
};

/**
 * Command sent from an AIFC staging area iframe to the parent Rovo chat frame whenever the
 * user's selection state changes (`hasSelection` is `false` on unmount). Avoids a side-effectful
 * read-content round trip to detect selection.
 *
 * @summary {@link CommandProperties.senderId} is notifying {@link CommandProperties.receiverId}
 * that the user's selection state in the staging area preview has changed.
 */
export const AifcStagingSelectionStateCommand: CommandConstructor<AifcStagingSelectionStateCommandProperties> =
	createCommand<AifcStagingSelectionStateCommandProperties>('aifc-staging-selection-state');
